import React from "react";
import { PiUserList } from "react-icons/pi";
import SectionCard from "components/card/SectionCard";
import VendorTable from "./VendorTable";

function Vendor() {
  return (
    <SectionCard
      title="Vendors"
      description="Manage vendor accounts and their organizations."
      icon={<PiUserList />}
      extra="overflow-hidden"
    >
      <VendorTable />
    </SectionCard>
  );
}

export default Vendor;
